import { NoInfer } from "@reduxjs/toolkit/dist/tsHelpers";
import { UndefinedInitialDataOptions, useQuery, useQueryClient } from "@tanstack/react-query";
import { Cookies, getCookie } from "../util/cookies";

export interface IMutateOpts {
  revalidate?: boolean
}

export type QueryOpts<T = any> = Omit<UndefinedInitialDataOptions<T>, "queryKey">;

export default function useCustomQuery<ResultT = any>(key: string | null, options: QueryOpts<ResultT> = {}) {

  const sessionToken = getCookie(Cookies.Session);
  const queryClient = useQueryClient();

  const queryKey = [key ?? ""];

  const queryOpts: UndefinedInitialDataOptions<ResultT> = {
    staleTime: 30000,
    enabled: !!sessionToken,
    ...options,
    keepPreviousData: true,
    queryKey
  };

  const content = useQuery<ResultT>(queryOpts);

  const {
    isLoading,
    refetch
  } = content;

  const mutate = async (updateFn?: (prev: NoInfer<ResultT> | undefined) => ResultT | undefined | null, opts: IMutateOpts = { revalidate: false }) => {
    const {
      revalidate
    } = opts;

    const res = (
      updateFn
        ? await queryClient.setQueryData<ResultT>(queryKey, old => updateFn(old) ?? undefined)
        : (await refetch())?.data
    );

    if (revalidate) queryClient.invalidateQueries({ queryKey });

    return res;
  }

  return {
    ...content,
    isLoading,
    isValidating: isLoading,
    mutate
  }
}